import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
let HomePage = class HomePage extends Vue {
    //
    handleClickRouterPush() {
        this.$router.push('/application/expat/application-list/expat_Information?parentId=8a7485c5865d839301865d967a690a64&code=expat_Information&openMode&pcUrl&queryCode=');
    }
    handleClickCreateExpat() {
        window.open('/form/createExpatInformation');
    }
};
HomePage = tslib_1.__decorate([
    Component({
        name: "HomePage",
        components: {
        //
        },
    })
], HomePage);
export default HomePage;
